import { Alert, Button } from "@mui/material";
import { motion } from "motion/react";
import { enqueueSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TbPlayerPause, TbPlayerPlay } from "react-icons/tb";

import { driverStatuses } from "@/constants/driverStatuses";
import { DRIVER_STATUS } from "@/constants/status";
import { calculateDiff } from "@/pages/WelcomeTeam";
import { CardItem } from "@/pages/WelcomeTeam/components/ChooseShift";
import { useShiftActions } from "@/stores/use-shift";
import { DriverStatus } from "@/types/daily-status.types";

function LandingShiftInfo({ currentShift }: { currentShift: DriverStatus }) {
    const status = driverStatuses.find((item) => item.status === currentShift.status);
    const { t } = useTranslation();
    const { updateShiftDecision, updateShowStartShiftConfirmation, updateShowCompleteShiftConfirmation } =
        useShiftActions();

    const handleStartShift = (val?: boolean) => {
        updateShiftDecision();
        updateShowStartShiftConfirmation(val);
    };
    const intervalId = useRef<ReturnType<typeof setInterval> | null>(null);
    const [timeDiff, setTimeDiff] = useState<[number, number, number] | null>(null);

    useEffect(() => {
        const cb = () => {
            if (!currentShift) {
                setTimeDiff(null);
                return;
            }
            const res = calculateDiff(currentShift.startTime);
            if (res) {
                setTimeDiff(res);
            }
        };

        intervalId.current = setInterval(cb, 4000);
        cb();

        return () => {
            if (intervalId.current) clearInterval(intervalId.current);
        };
    }, [currentShift]);

    const handleStopShift = () => {
        if (!currentShift || !currentShift.startTime) return;
        const diff = calculateDiff(currentShift.startTime);
        if (!diff) return;
        else if (currentShift.status === DRIVER_STATUS.WORKING && (!diff[0] || diff[0] < 1)) {
            enqueueSnackbar("Mesai 1 saatten erken bitirilemez.", { variant: "error" });
            return;
        } else if (
            ![DRIVER_STATUS.WORKING, DRIVER_STATUS.FREE_DAY].includes(currentShift.status as "WORKING" | "FREE_DAY")
        ) {
            enqueueSnackbar(
                "Haftalık izin dışındaki durumları bitirmek için lütfen yöneticiniz ile iletişime geçin." +
                    (currentShift.endTime
                        ? "İzin bitiş tarihi:" + currentShift.endTime.toFormat("yyyy-MM-dd HH:mm")
                        : ""),
                {
                    variant: "error",
                }
            );
            return;
        }
        if (currentShift.status === DRIVER_STATUS.WORKING) updateShowCompleteShiftConfirmation(true);
        else handleStartShift(true);
    };

    return status && timeDiff ? (
        <>
            <motion.div className="grid grid-cols-1  gap-3 lg:gap-6    py-2 overflow-hidden max-w-full">
                <CardItem
                    custom={+(+`0.0` + 0.4)}
                    icon={status.component()}
                    title={t("driverStatuses." + status.status)}
                    description={t(`driverStatuses.${status.status}_TIME`, {
                        hours: timeDiff[0],
                        minutes: timeDiff[1],
                    })}
                    handleClick={() => void 0}
                >
                    <div className="flex  lg:justify-end">
                        {status.status === DRIVER_STATUS.FREE_DAY && (
                            <Button
                                onClick={handleStopShift}
                                startIcon={<TbPlayerPlay />}
                                color="primary"
                                variant="text"
                            >
                                Mesaimi Başlat
                            </Button>
                        )}
                        {status.status === DRIVER_STATUS.WORKING && timeDiff[0] >= 1 && (
                            <Button
                                onClick={handleStopShift}
                                startIcon={<TbPlayerPause />}
                                color="primary"
                                variant="text"
                            >
                                Mesaimi Bitir
                            </Button>
                        )}
                    </div>
                </CardItem>
            </motion.div>
        </>
    ) : (
        <Alert>Durum bulunamadı.Lütfen yöneticiniz ile ietişime geçiniz</Alert>
    );
}

export default LandingShiftInfo;
